import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as workspaces from '../../workspaces'

export const RESOURCE = {
  payload: {
    description:
      'A logical grouping for organizing related conversations into projects or collections.',
    dimension: workspaces.RESOURCE.payload,
    level: 0,
    name: 'Workspace',
    partialId: PartialId.Standard.create('workspace'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
